import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

// FIDA is Coras's own crypto/loyalty app (apps/fida), not a microsite, but its
// brand belongs in the store so the app, the emails `fida` templates, and the
// Studio preview all theme from one source. The app injects its distributorId
// per environment via VITE_DISTRIBUTOR_ID; the value here matches the manifest.
export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "734b181c-db44-4619-a852-302c28d1a6e3",
  title: "FIDA Loyalty",
  description: "Crypto rewards and loyalty for travel bookings",
  locale: "en-IE",
  currency: "EUR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: [],
  logo: "/assets/images/logo.svg",
  domain: "fida.coras.io",
  detectLocale: true,
  detectCurrency: true,
};
